import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

/**
 * `.timeline` — the drawer's Actividad rail. `dot` selects the marker tone;
 * the rail/dot positioning is plain CSS in entity-list.css (see comment
 * there) since it's pseudo-element-heavy and per-item colored.
 */
function Timeline({ items }) {
	return (
		<div className='timeline tw:flex tw:flex-col tw:gap-4'>
			{items.map((item, index) => (
				<div key={index} className={classnames('tl-item', item.dot && `dot-${item.dot}`)}>
					<div className='tw:text-[11.5px] tw:font-medium tw:text-ink-3'>{item.date}</div>
					<div className='tw:text-[13.5px] tw:font-medium tw:text-ink-0'>{item.title}</div>
					{item.sub && <div className='tw:text-[12.5px] tw:text-ink-2'>{item.sub}</div>}
				</div>
			))}
		</div>
	);
}

Timeline.propTypes = {
	items: PropTypes.arrayOf(
		PropTypes.shape({
			date: PropTypes.node,
			title: PropTypes.node.isRequired,
			sub: PropTypes.node,
			dot: PropTypes.oneOf(['accent', 'ok', 'danger']),
		}),
	).isRequired,
};

export default Timeline;
